<!-- Sub comments section -->

@for (subComment of postSubComment.subCommentList; track subComment) {
<article class="media">
  <figure class="media-left">
    <p class="image is-32x32">
      @if (!subComment.user_detail.user_icon) {
      <empty-uname
        [userName]="subComment.user_detail.full_name"
        [detailHeadProfile]="true"
      ></empty-uname>
      } @if (subComment.user_detail.user_icon) {
      <img [src]="profileUrl + subComment.user_detail.user_icon" />
      }
    </p>
  </figure>
  <div class="media-content">
    <div class="content">
      <div>
        <strong class="cmt-u-name">{{
          subComment.user_detail.full_name
        }}</strong>
        <small class="timeago text-clr-grey">
          {{ subComment.createdAt | amTimeAgo }}
        </small>
      </div>
      <div class="cmt-text">
        <small class="">{{ subComment.sub_comment }}</small>
      </div>
    </div>
  </div>
</article>
} @if (postSubComment.subCommentList.length && (postSubComment.subCommentsCount
> postSubComment.subCommentList.length)) {
<div class="mar-10-0">
  <a
    class="button is-info is-small"
    (click)="loadMoreSubComments(postSubComment)"
    >More</a
  >
</div>
}

<!-- Sub comment section ends -->
